import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserPlantList } from "../store/actions/userActions";
import { IconButton, Menu, MenuItem, Tooltip, Typography } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import { useTranslation } from "react-i18next";
import ls from "local-storage";

const SelectPlant = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const { t } = useTranslation("translation");
    const [plantList, setPlantList] = useState([]);
    const dispatch = useDispatch();
    const [renderMobileScreen, setRenderMobileScreen] = useState(false);

    useEffect(() => {
        GetPlantCodeHandler();
    }, []);

    const GetPlantCodeHandler = () => {
        const oktaToken = JSON.parse(localStorage.getItem("okta-token-storage"));
        if (oktaToken && oktaToken.idToken) {
            const userCode = oktaToken.idToken.claims.preferred_username.replace("@arcelik.com", "");

            let payload = {
                userCode: userCode,
                fromUser: false,
            };
            dispatch(getUserPlantList(payload));
        }
    };

    const {
        user: { userPlantList },
    } = useSelector((user) => user);

    useEffect(() => {
        if (userPlantList?.resultObject) {
            // It should return true from Api
            const { resultObject } = userPlantList;
            setPlantList(resultObject);
            if (ls.get("plantId") && resultObject.some((e) => e.id == ls.get("plantId"))) {
                SetPlant(ls.get("plantId"));
            } else {
                SetPlant(resultObject[0].id);
                ls.set("plantCode", resultObject[0].code);
            }
        }
    }, [userPlantList]);

    useEffect(() => {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
            setRenderMobileScreen(true);
        } else {
            setRenderMobileScreen(false);
        }
    }, [window.navigator.userAgent]);

    const RefreshPage = () => {
        window.location.reload(true);
    };

    const SetPlant = (id) => {
        ls.set("plantId", id);
    };

    const HandleMenuItemClick = (_event, index) => {
        ls.set("selectedIndex", index);
        ls.set("plantCode", plantList[index].code);
        SetPlant(plantList[index].id);
        setAnchorEl(null);
        RefreshPage();
    };

    return (
        <div>
            <Tooltip id="spl_Tooltip" title={t("Plant")}>
                <IconButton id="spl_IconButton" aria-label="plant-select" color="inherit" onClick={(event) => setAnchorEl(event.currentTarget)} size="large">
                    <BusinessIcon id="spl_BsnssIcon" />
                    {renderMobileScreen ? <Typography style={{marginLeft: "10px"}}>{t("Plant")}</Typography> : null}
                </IconButton>
            </Tooltip>
            <Menu id="lock-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
                {plantList.map((plant, index) => (
                    <MenuItem id={"sp_MenuItem_" + index} key={index} selected={index === ls.get("selectedIndex")} onClick={(event) => HandleMenuItemClick(event, index)}>
                        {plant.code}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
};

export default SelectPlant;
